<template>
    <main>
        <!-- breadcrumb-area-start -->
        <div class="it-breadcrumb-area it-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/breadcrumb/breadcrumb.png)' }">
            <div class="container">
                <div class="row ">
                    <div class="col-md-12">
                        <div class="it-breadcrumb-content z-index-3 text-center">
                            <div class="it-breadcrumb-title-box">
                                <h3 class="it-breadcrumb-title">Achievers Edge</h3>
                            </div>
                            <div class="it-breadcrumb-list-wrap">
                                <div class="it-breadcrumb-list">
                                    <span><a href="#">home</a></span>
                                    <span class="dvdr">//</span>
                                    <span>Achievers Edge</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- breadcrumb-area-end -->

        <div class="it-sv-details-area pt-120 pb-120">
            <div class="container">
                <div class="row">
                    <div class="col-xl-12 col-lg-12">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="it-sv-details-top-content mb-50">
                                    <h4 class="it-sv-details-title">Why Achievers Instiute of Management and
                                        Entrepreneurship?</h4>
                                    <ul>
                                        <li>AICTE Entitled Degree</li>
                                        <li>Industry relevant curriculum</li>
                                        <li>Monthly Master class with Industry Expert</li>
                                        <li>Flexible payment options</li>
                                        <li>Workshops, Industrial Visit & Simulated Games</li>
                                        <li>Business Incubation Centre approved by Ministry of MSME</li>
                                        <li>Assistance in setting up your business / Guaranteed Placement Opportunities
                                        </li>
                                        <li>Guidance in Documentation and Fund Generation for setting up business</li>
                                        <li>Concessional rate foreign study tour to Dubai/Singapore/ Thailand</li>
                                        <li>Domestic Industrial visits and field visits every month</li>
                                        <li>Attractive Scholarship for Girls and Caste eligible students</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
export default {
    name: "AchieversView"
};
</script>
